import React from "react";
import { Accordion, Table } from "semantic-ui-react";

class SimpleAccordionContent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activeIndex: props.defaultFold ? -1 : 0,
    };
  }

  handleClick = () => {
    if (this.state.activeIndex === 0) {
      this.setState({ activeIndex: -1 });
    } else {
      this.setState({ activeIndex: 0 });
    }
  };

  render() {
    const props = this.props;
    const accTitle = (
      <Accordion.Title
        className="report-section-header"
        active={this.state.activeIndex === 0}
        key={`${props.name}Title`}
        onClick={() => this.handleClick()}
      >
        <p>
          {props.name}
          <span className={"report-section-title"}>
            {this.state.activeIndex === 0 ? "-" : "+"}
          </span>
        </p>
      </Accordion.Title>
    );
    const accContent = (
      <Accordion.Content
        key={`${props.name}Body`}
        active={this.state.activeIndex === 0}
      >
        <Table
          className={`table-no-border-and-padding ${
            props.additionalClasses ? props.additionalClasses : ""
          }`}
        >
          <Table.Body>{props.rows}</Table.Body>
        </Table>
      </Accordion.Content>
    );
    if (!this.props.accId)
      return (
        <Accordion fluid styled>
          {accTitle}
          {accContent}
        </Accordion>
      );
    return (
      <Accordion fluid styled id={this.props.accId} className={props.custClass !== "" ? props.custClass : ""}>
        {accTitle}
        {accContent}
      </Accordion>
    );
  }
}

export default SimpleAccordionContent;



// WEBPACK FOOTER //
// ./src/components/common/SimpleAccordionContent.js